var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["emp.col.entrance.entranceName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "entranceId"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseChoose"] +
                                  _vm.language["emp.col.entrance.entranceName"],
                                allowClear: "",
                                disabled: _vm.formDisabled
                              },
                              on: { change: _vm.entranceChange },
                              model: {
                                value: _vm.model.entranceId,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "entranceId", $$v)
                                },
                                expression: "model.entranceId"
                              }
                            },
                            _vm._l(_vm.entrancelist, function(item, index) {
                              return _c(
                                "a-select-option",
                                {
                                  key: index.toString(),
                                  attrs: { value: item.id }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.entranceName) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["ad.name"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "title"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              placeholder:
                                _vm.language["ad.must"] +
                                _vm.language["ad.name"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.title,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "title", $$v)
                              },
                              expression: "model.title"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: {
                                type: "primary",
                                disabled: _vm.formDisabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "cms_banner",
                                    "title",
                                    _vm.contentTitleLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["hhemp.ad.jump.type"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "linkType"
                          }
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              attrs: { disabled: _vm.formDisabled },
                              on: { change: _vm.filecontentChange },
                              model: {
                                value: _vm.model.linkType,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "linkType", $$v)
                                },
                                expression: "model.linkType"
                              }
                            },
                            [
                              _c(
                                "a-radio",
                                {
                                  attrs: { value: "0" },
                                  on: {
                                    click: function($event) {
                                      return _vm.contentTypeCh(true)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.language["ad.link"]))]
                              ),
                              _c(
                                "a-radio",
                                {
                                  attrs: { value: "1" },
                                  on: {
                                    click: function($event) {
                                      return _vm.contentTypeCh(false)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language["eletronicSigned.fileUrls"]
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["hhemp.lang.setting"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c(
                            "a-tabs",
                            {
                              staticStyle: {
                                border: "1px solid #262626",
                                "border-radius": "5px"
                              },
                              attrs: { defaultActiveKey: "1" }
                            },
                            _vm._l(_vm.langList, function(item, index) {
                              return _c(
                                "a-tab-pane",
                                {
                                  key: index,
                                  attrs: { tab: _vm.language[item.value] }
                                },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          attrs: {
                                            label: _vm.language["hhemp.ad.img"],
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                            prop: "remark"
                                          }
                                        },
                                        [
                                          _c("j-image-upload", {
                                            staticClass: "avatar-uploader",
                                            attrs: {
                                              text:
                                                _vm.language[
                                                  "common.uploadButton"
                                                ],
                                              "upload-source": _vm.uploadSource,
                                              multiple: false,
                                              disabled: _vm.formDisabled
                                            },
                                            model: {
                                              value: _vm.model[item.imgPath],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  item.imgPath,
                                                  $$v
                                                )
                                              },
                                              expression: "model[item.imgPath]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.contentTypeChecked
                                    ? _c(
                                        "a-col",
                                        { attrs: { span: 24 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            {
                                              attrs: {
                                                label: _vm.language["ad.link"],
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol
                                              }
                                            },
                                            [
                                              _c("a-textarea", {
                                                staticStyle: { width: "80%" },
                                                attrs: {
                                                  placeholder:
                                                    _vm.language["ad.must"] +
                                                    _vm.language["ad.link"],
                                                  disabled: _vm.formDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.model[item.linkUrl],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      item.linkUrl,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model[item.linkUrl]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.contentFileChecked
                                    ? _c(
                                        "a-col",
                                        { attrs: { span: 24 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.language[
                                                    "eletronicSigned.fileUrls"
                                                  ],
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol
                                              }
                                            },
                                            [
                                              _c("j-upload", {
                                                attrs: {
                                                  "file-type": "file",
                                                  uploadSource: "hhemp",
                                                  bizPath: "null",
                                                  newWindowOpen: "true",
                                                  disabled: _vm.formDisabled,
                                                  number: 0,
                                                  multiple: false
                                                },
                                                on: {
                                                  change: _vm.handleChange
                                                },
                                                model: {
                                                  value:
                                                    _vm.model[item.filePath],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      item.filePath,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model[item.filePath]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "a-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          attrs: {
                                            label:
                                              _vm.language["hhemp.ad.remark"],
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                            prop: "remark"
                                          }
                                        },
                                        [
                                          _c("a-textarea", {
                                            staticStyle: { width: "80%" },
                                            attrs: {
                                              maxLength: "1000",
                                              rows: "4",
                                              placeholder:
                                                _vm.language["ad.must"] +
                                                _vm.language["hhemp.ad.remark"],
                                              disabled: _vm.formDisabled
                                            },
                                            model: {
                                              value:
                                                _vm.model[item.introduction],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  item.introduction,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model[item.introduction]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["platform.roleUser.columns2.status"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "publishStatus"
                          }
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              attrs: { disabled: _vm.formDisabled },
                              on: { change: _vm.filecontentChange },
                              model: {
                                value: _vm.model.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "status", $$v)
                                },
                                expression: "model.status"
                              }
                            },
                            [
                              _c(
                                "a-radio",
                                { attrs: { value: "0", readOnly: true } },
                                [_vm._v(_vm._s(_vm.language["ad.offline"]))]
                              ),
                              _c(
                                "a-radio",
                                { attrs: { value: "1", readOnly: true } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language["emp.col.status.publish"]
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.sortNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 1,
                              max: 999999,
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.col.sortNo"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("language-model", {
            ref: "languageModel",
            on: { ok: _vm.languageOk }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }